import { bridge } from './bridge';
import { utils } from './utils';
import { CONTEXT } from '../config/index';
import { cacheKeys } from '../constants/storageKeys';
import { capitalizeObj, logNative, logging, addCookie } from '../utils/utils';
import { reject } from 'lodash-es';
import message from '../reducers/message';
// import { logging } from '../../actions/log';

/**
 * 忽略当前版本
 * @param {*} soft
 */
function ignoreSoftUpdate(soft, flag, permanentIgnore) {
  const params = {
    softID: soft.softID || soft.softId,
    androidType: soft.androidType,
    version: soft.version,
    bIgnore: flag,
    permanentIgnore,
  };
  if (soft.androidType === '1') {
    params.packageName = soft.packageName;
    params.versionCode = soft.versionCode;
  }
  return new Promise((resolve, reject) => {
    bridge.requestNative(
      'APKS_PC_REQ_IGNORE_SOFTWARE',
      JSON.stringify(params),
      (success, message) => {
        if (success) {
          logNative(
            `发起忽略当前版本请求完成 结果：${success} 返回内容：${message}`,
            { params, flag, success, message },
            true,
            true,
          );
          // 发起忽略当前版本请求成功
          try {
            const msgObj = JSON.parse(message);
            return resolve(msgObj);
          } catch (error) {
            logNative(`接口调用 APKS_PC_REQ_IGNORE_SOFTWARE JSON解析错误:${error}`, error);
            return resolve(false);
          }
        }
        return reject(new Error('APKS_PC_REQ_IGNORE_SOFTWARE failed'));
      },
    );
  });
}

// 生成桌面快捷方式
function createDesktopIcon(soft) {
  const params = {
    softid: soft.softID,
    pkg: soft.packageName,
    vc: soft.versionCode || 0,
    vn: soft.version,
    icon: soft.logoFile,
  };
  return new Promise((resolve, reject) => {
    bridge.requestNative('APKS_REQ_ICON_CREAT', JSON.stringify(params), (success, message) => {
      if (success) {
        // 发起下载请求成功
        try {
          const msgObj = JSON.parse(message);
          logNative(`创建桌面图标:${JSON.stringify(params)}`, msgObj);
          return resolve(msgObj);
        } catch (error) {
          logNative(`接口调用 APKS_REQ_ICON_CREAT JSON解析错误:${error}`, error);
          return resolve(false);
        }
      }
      return reject(new Error('APKS_REQ_ICON_CREAT failed'));
    });
  });
}

// 获取用户登录后的 用户token信息
function getUserTokenInfo(ltoken) {
  return new Promise((resolve, reject) => {
    bridge.requestNative(
      'APPSTORE_GET_TOKEN_INFO',
      JSON.stringify(ltoken || {}),
      (success, message) => {
        if (success) {
          // 发起下载请求成功
          try {
            const msgObj = JSON.parse(message);
            logNative(`接口调用 APPSTORE_GET_TOKEN_INFO 获取用户token:${message}`, {}, true, true);
            return resolve(msgObj.data);
          } catch (error) {
            logNative(`接口调用 APPSTORE_GET_TOKEN_INFO JSON解析错误:${error}`, error);
            return resolve(false);
          }
        }
        return reject(new Error('APPSTORE_GET_TOKEN_INFO failed'));
      },
    );
  });
}

// 检测电脑是否打开VT模式
function getIsVTEabled() {
  return new Promise((resolve, reject) => {
    bridge.requestNative('APKS_REQ_ISVT_ENABLED', JSON.stringify({}), (success, message) => {
      if (success) {
        // 发起下载请求成功
        try {
          const msgObj = JSON.parse(message);
          logNative(`接口 APKS_REQ_ISVT_ENABLED 返回值`, msgObj);
          return resolve(msgObj);
        } catch (error) {
          logNative(`接口调用 APKS_REQ_ISVT_ENABLED JSON解析错误:${error}`, error);
          return resolve(false);
        }
      }
      return reject(new Error('APKS_REQ_ISVT_ENABLED failed'));
    });
  });
}

// 检测电脑模拟器是否正在运行
function getIsSIMRunning() {
  return new Promise((resolve, reject) => {
    bridge.requestNative('APKS_REQ_VM_ISRUNNING', JSON.stringify({}), (success, message) => {
      if (success) {
        // 发起下载请求成功
        try {
          const msgObj = JSON.parse(message);
          return resolve(msgObj.running);
        } catch (error) {
          logNative(`接口调用 APKS_REQ_VM_ISRUNNING JSON解析错误:${error}`, error);
          return resolve(false);
        }
      }
      return reject(new Error('APKS_REQ_VM_ISRUNNING failed'));
    });
  });
}

// 检测电脑模拟器是否已经安装
function getIsSIMInstalled() {
  return new Promise((resolve, reject) => {
    bridge.requestNative('APKS_REQ_VM_ISINSTALLED', JSON.stringify({}), (success, message) => {
      if (success) {
        // 发起下载请求成功
        try {
          const msgObj = JSON.parse(message);
          return resolve(msgObj.installed);
        } catch (error) {
          logNative(`接口调用 APKS_REQ_VM_ISINSTALLED JSON解析错误:${error}`, error);
          return resolve(false);
        }
      }
      return reject(new Error('APKS_REQ_VM_ISINSTALLED failed'));
    });
  });
}

// 生成桌面快捷方式
function getDesktopIcon(soft) {
  const params = {
    softid: soft.softID,
    pkg: soft.packageName,
    vc: soft.versionCode || 0,
    vn: soft.version,
    icon: soft.logoFile,
  };
  return new Promise((resolve, reject) => {
    bridge.requestNative('APKS_REQ_ICON_EXIST', JSON.stringify(params), (success, message) => {
      if (success) {
        // 发起下载请求成功
        try {
          const msgObj = JSON.parse(message);
          return resolve(msgObj.data);
        } catch (error) {
          logNative(`接口调用 APKS_REQ_ICON_EXIST JSON解析错误:${error}`, error);
          return resolve(false);
        }
      }
      return reject(new Error('APKS_REQ_ICON_EXIST failed'));
    });
  });
}

// 安卓安装软件,升级软件
function installAndroidSoft(soft) {
  logging({
    category: 'R',
    action: 'D_Pd',
    label: '',
    param2: { ...soft.logInfo, isClick: soft.isClick || '' },
    param3: soft.bizInfo || null,
  });
  let downLoadUrl = soft.downloadUrl || soft.downLoadUrl || '';
  const installParam = localStorage.getItem(cacheKeys.INSTALL_PARAM);

  let bizInfo = soft.bizInfo || '';
  if (typeof soft.bizInfo === 'object') {
    bizInfo = JSON.stringify(soft.bizInfo);
  }
  try {
    if (downLoadUrl.indexOf('?') > -1) {
      downLoadUrl = `${downLoadUrl}&param=${btoa(
        `${installParam}&bizInfo=${encodeURIComponent(bizInfo)}`,
      )}`;
    } else {
      downLoadUrl = `${downLoadUrl}?param=${btoa(
        `${installParam}&bizInfo=${encodeURIComponent(bizInfo)}`,
      )}`;
    }
  } catch (error) {
    logNative(
      `installAndroidSoft 解析参数错误 ${installParam}&bizInfo=${encodeURIComponent(bizInfo)}`,
      error,
    );
  }

  const params = {
    softid: soft.softID,
    pkg: soft.packageName,
    vc: soft.versionCode || 0,
    vn: soft.version,
    dl: downLoadUrl,
    sz: soft.size,
    md5: soft.apkMd5,
    icon: soft.logoFile,
  };
  logNative(`开始调用安卓安装升级软件 下载地址：${downLoadUrl}`, params, false, true);

  return new Promise((resolve, reject) => {
    bridge.requestNative('APKS_REQ_INSTALL', JSON.stringify(params), (success, message) => {
      if (success) {
        // 发起下载请求成功
        try {
          const msgObj = JSON.parse(message);
          // 如果调用下载失败就，调一次客户端的删除下载任务，前端显示的界面任务列表保留
          if (msgObj.succ !== 'true') {
            cancelAndroidDownload(soft);
          }
          // return resolve(msgObj.succ);
          return resolve(true);
        } catch (error) {
          logNative(`接口调用 APKS_REQ_INSTALL JSON解析错误:${error}`, error);
          return resolve(false);
        }
      }
      return reject(new Error('APKS_REQ_INSTALL failed'));
    });
  });
}

// 安卓卸载软件
function uninstallAndroidSoft(soft) {
  const params = {
    softid: soft.softID,
    pkg: soft.packageName,
    vc: soft.versionCode || 0,
    vn: soft.version,
  };
  return new Promise((resolve, reject) => {
    bridge.requestNative('APKS_REQ_UNINSTALL', JSON.stringify(params), (success, message) => {
      // 发起下载请求成功后回调函数
      if (success) {
        try {
          const msgObj = JSON.parse(message);
          return resolve(msgObj.succ);
        } catch (error) {
          logNative(`接口调用 APKS_REQ_UNINSTALL JSON解析错误:${error}`, error);
          return resolve(false);
        }
      }
      return reject(new Error('APKS_REQ_UNINSTALL failed'));
    });
  });
}

// 安卓取消下载
function cancelAndroidDownload(soft) {
  bridge.requestNative(
    'APKS_REQ_CANCEL_INSTALL',
    JSON.stringify({
      softid: soft.softID,
      pkg: soft.packageName,
      vc: soft.versionCode.toString() || '0',
      vn: soft.version,
    }),
  );
}

// 安卓运行打开软件
function openAndroidSoft(soft) {
  return new Promise((resolve, reject) => {
    bridge.requestNative(
      'APKS_REQ_RUN',
      JSON.stringify({
        softid: soft.softID,
        pkg: soft.packageName,
        vc: soft.versionCode.toString() || '0',
        vn: soft.version,
      }),
      (success, message) => {
        // 发起下载请求成功
        if (success) {
          try {
            const msgObj = JSON.parse(message);
            return resolve(msgObj.code === 0);
          } catch (error) {
            logNative(`接口调用 APKS_REQ_RUN JSON解析错误:${error}`, error);
            return resolve(false);
          }
        }
        return reject(new Error('APKS_REQ_RUN failed'));
      },
    );
  });
}

// 获取安卓本地安装的软件
function getLocalInstalledAndroidSoft() {
  return new Promise((resolve, reject) => {
    bridge.requestNative('APKS_REQ_PKG_LIST', JSON.stringify({}), (success, message) => {
      if (success) {
        // 获取了安卓本地安装列表以后才能调用获取更新列表
        // getAndroidPCUpdateSoft();
        try {
          const { pkgs } = JSON.parse(message);
          return resolve(pkgs || []);
        } catch (error) {
          logNative(`接口调用 APKS_REQ_PKG_LIST JSON解析错误:${error}`, error);
          return resolve([]);
        }
      }
      return reject(new Error('APKS_REQ_PKG_LIST failed'));
    });
  });
}

// 获取安装的PC和安卓的更新软件
function getAndroidPCUpdateSoft() {
  // 请求升级的信息
  return new Promise((resolve, reject) => {
    bridge.requestNative('APKS_PC_REQ_UPGRADE_LIST', JSON.stringify({}), (success, message) => {
      // 发起下载请求成功
      if (success) {
        try {
          const msgObj = JSON.parse(message);
          return resolve(msgObj.succ);
        } catch (error) {
          logNative(`接口调用 APKS_PC_REQ_UPGRADE_LIST JSON解析错误:${error}`, error);
          return resolve(false);
        }
      }
      return reject(new Error('APKS_PC_REQ_UPGRADE_LIST failed'));
    });
  });
}

/**
 * 打开某一个软件
 * @param {*} mainExePath
 */
function openSoft(softInfo) {
  // bridge.requestNative('APPSTORE_OPENSOFT', mainExePath);
  return new Promise((resolve, reject) => {
    bridge.requestNative(
      'APPSTORE_OPENSOFT',
      JSON.stringify({
        SoftID: softInfo.SoftID,
        softGUID: softInfo.softGUID,
        displayName: softInfo.displayName,
        MainExePath: softInfo.MainExePath,
      }),
      (success, message) => {
        // 发起下载请求成功
        if (success) {
          try {
            const msgObj = JSON.parse(message);
            return resolve(msgObj.open);
          } catch (error) {
            logNative(`接口调用 APPSTORE_OPENSOFT JSON解析错误:${error}`, error);
            return resolve(false);
          }
        }
        return reject(new Error('APPSTORE_OPENSOFT failed'));
      },
    );
  });
}

// 判断是否需要强力卸载
function judgeUninstallSoft(param) {
  return new Promise((resolve, reject) => {
    bridge.requestNative(
      'APPSTORE_REQ_UNINSTALLSOFT_MODE',
      JSON.stringify(param),
      (success, message) => {
        if (success) {
          return resolve(JSON.parse(message));
        }
        return reject(new Error('APPSTORE_REQ_UNINSTALLSOFT_MODE failed'));
      },
    );
  });
}

// 强力卸载软件
function constraintUninstall(soft) {
  bridge.requestNative(
    'APPSTORE_START_FORCE_UNINSTALL',
    JSON.stringify({ softGUID: soft.softGUID }),
  );
}

// 卸载软件
function uninstallSoft(soft) {
  bridge.requestNative('APPSTORE_UNINSTALLSOFT', JSON.stringify(soft));
}

// 取消下载
function cancelDownload(softID) {
  bridge.requestNative('APPSTORE_CANCELdOWNLOAD', softID);
}

// 获取本地安装的软件
function getLocalInstalledSoft() {
  window.getUpdateStartTime = new Date().getTime();
  return new Promise((resolve, reject) => {
    bridge.requestNative('APPSTORE_GETLOCALSOFTWAREINFO', null, (success, message) => {
      if (success) {
        // 获取了本地安装列表以后才能调用更新
        // getUpdateSoft();
        try {
          const { info } = JSON.parse(message);
          return resolve(info);
        } catch (error) {
          logNative(`接口调用 APPSTORE_GETLOCALSOFTWAREINFO JSON解析错误:${error}`, error);
          return resolve([]);
        }
      }
      return reject(new Error('APPSTORE_GETLOCALSOFTWAREINFO failed'));
    });
  });
}

function getLocalInstalledSoftNoXml() {
  return new Promise((resolve, reject) => {
    bridge.requestNative('APPSTORE_GETLOCALSOFTWAREINFO_NOTRANSFER', null, (success, message) => {
      if (success) {
        try {
          const { info } = JSON.parse(message);
          return resolve(info);
        } catch (error) {
          logNative(
            `接口调用 APPSTORE_GETLOCALSOFTWAREINFO_NOTRANSFER JSON解析错误:${error}`,
            error,
          );
          return resolve([]);
        }
      }
      return reject(new Error('APPSTORE_GETLOCALSOFTWAREINFO_NOTRANSFER failed'));
    });
  });
}

function getUpdateSoft() {
  // 请求升级的信息
  bridge.requestNative('APPSTORE_GET_SERVER_UPDATEINFO');
}

// 移动窗口
function startMoveWindow() {
  utils.sendNativeMessage('HtCaption');
}
// 移动窗口
function touchStartWindow(param) {
  let coordinate = `${~~param.screenX}, ${~~param.screenY}`;
  utils.sendNativeMessage('TouchStartDrag', coordinate);
}
function touchMoveWindow(param) {
  let coordinate = `${~~param.screenX}, ${~~param.screenY}`;
  utils.sendNativeMessage('TouchMoveDrag', coordinate);
}
function touchEndWindow(param) {
  utils.sendNativeMessage('TouchEndDrag');
}
// 最小化窗口
function minimizeWindow() {
  utils.sendNativeMessage('Minimize');
}

// 最大化窗口
function maximizeWindow() {
  bridge.requestNative('APPSTORE_MAXIMIZE');
  // utils.sendNativeMessage('Maximize');
  // utils.sendNativeMessage('Maximize');
}
// 还原窗口
function middleWindow() {
  bridge.requestNative('APPSTORE_RESTORE');
  // utils.sendNativeMessage('Middle');
}

// 关闭窗口
function closeWindow() {
  window.close();
}

/**
 * 2020-5-9 15:00:03 新增接口   主要是传入sessionId,以后可扩展其他参数
 */
function getStartInfo() {
  bridge.requestNative('PCM_MESSAGE_MODULE_COMMON');
}

/**
 * 获取设备信息
 */
function getLocalMachineInfo() {
  return new Promise((resolve, reject) => {
    bridge.requestNative('APPSTORE_GET_LOCALMACHINEINFO', null, (success, message) => {
      if (success) {
        // 非联想机器信息默认值 {"MAC":"unknown","MT":"unknown","OS":"win7","OSbit":"32","SN":"unknown","UUID":"unknown"}
        const result = {
          MAC: 'unknown',
          MT: 'unknown',
          OS: 'Windows 7',
          OSbit: '32',
          SN: 'unknown',
          UUID: 'unknown',
          ludp_uuid: 'unknown',
          leas_runtime: 'unknown',
          osBuild: 'unknown',
        };
        try {
          const res = JSON.parse(message);
          // Object.keys(result).forEach(v => {
          //   if (res[v]) result[v] = res[v];
          // });
          result.MAC = res.MAC || 'unknown';
          result.MT = res.MT || 'unknown';
          result.OS = res.OS || 'Windows 7';
          result.OSbit = res.OSbit || '32';
          result.SN = res.SN || 'unknown';
          result.UUID = res.UUID || 'unknown';
          result.ludp_uuid = `${res.ludp_uuid}` || 'unknown';
          result.leas_runtime = res.leas_runtime || 'unknown';
          result.osBuild = res.osBuild || 'unknown';
          addCookie('avatar_name', encodeURIComponent(`${res.ludp_uuid}` || 'error_ludp_uuid'), 30);

          setTimeout(() => {
            logging({
              category: 'R',
              action: 'R_MachineInfo',
              label: '',
              param2: { message: res, result: result },
            });
          }, 1000);
        } catch (error) {
          logNative(`接口调用 APPSTORE_GET_LOCALMACHINEINFO JSON解析错误:${error}`, error);
        }
        if (result.OS.indexOf('Windows 7') !== -1) {
          result.OS = 'win7';
        } else if (result.OS.indexOf('Windows 8') !== -1) {
          result.OS = 'win8';
        } else if (result.OS.indexOf('Windows 8.1') !== -1) {
          result.OS = 'win8_1';
        } else if (result.OS.indexOf('Windows 10') !== -1) {
          result.OS = 'win10';
        } else if (result.OS.indexOf('Windows XP') !== -1) {
          result.OS = 'winxp';
        } else if (result.OS.indexOf('Windows Vista') !== -1) {
          result.OS = 'vista';
        }

        logNative(
          `接口 APPSTORE_GET_LOCALMACHINEINFO 获取设备信息返回结果 ${JSON.stringify(result)}`,
          true,
        );
        localStorage.setItem(cacheKeys.LOCALMACHINE_INFO, JSON.stringify(result));
        return resolve(result);
      }
      return reject(new Error('APPSTORE_GET_LOCALMACHINEINFO failed'));
    });
  });
}

function checkPINExits() {
  return new Promise((resolve, reject) => {
    bridge.requestNative('APPSTORE_GET_PINSTATUS', null, (success, message) => {
      if (success) {
        let ret = {};
        try {
          ret = JSON.parse(message);
        } catch (error) {
          logNative(`接口调用 APPSTORE_GET_PINSTATUS JSON解析错误:${error}`, error);
        }
        resolve(ret);
      }
      reject(new Error('APPSTORE_GET_PINSTATUS failed'));
    });
  });
}

/**
 * 检查是否有壁纸的快捷方式
 */
function checkWALLPAPERxits() {
  return new Promise((resolve, reject) => {
    bridge.requestNative('APPSTORE_GET_PINWALLPAPER_STATUS', null, (success, message) => {
      if (success) {
        let ret = {};
        try {
          ret = JSON.parse(message);
        } catch (error) {
          logNative(`调用接口APPSTORE_GET_PINWALLPAPER_STATUS解析错误:${error}`, error);
        }
        resolve(ret);
      }
      reject(new Error('APPSTORE_GET_PINWALLPAPER_STATUS failed'));
    });
  });
}

function pinDesktopIcon() {
  return new Promise((resolve, reject) => {
    bridge.requestNative('APPSTORE_PINDESKTOP', null, (success, message) => {
      if (success) {
        resolve(message);
      } else {
        reject(new Error('APPSTORE_PINDESKTOP failed'));
      }
      logNative(`接口调用 APPSTORE_PINDESKTOP 结果: ${success}; message: ${message}`);
    });
  });
}

/**
 * 创建壁纸快捷方式
 */

function wallpaperDesktop() {
  return new Promise((resolve, reject) => {
    bridge.requestNative('APPSTORE_PINDESKTOP_WALLPAPER', null, (success, message) => {
      if (success) {
        resolve(message);
      } else {
        reject(new Error('APPSTORE_PINDESKTOP_WALLPAPER failed'));
      }
      logNative(`调用接口 APPSTORE_PINDESKTOP_WALLPAPER 结果： ${success}; message: ${message}`);
    });
  });
}

/**
 * 获取其他信息，包含下载路径
 */
function getOtherInfo() {
  return new Promise((resolve, reject) => {
    bridge.requestNative('APPSTORE_GET_OTHERINFO', null, (success, message) => {
      if (success) {
        let result = {};
        try {
          result = JSON.parse(message);
        } catch (error) {
          logNative(`接口调用 APPSTORE_GET_OTHERINFO JSON解析错误:${error}`, error);
        }
        return resolve(result);
      }
      return reject(new Error('APPSTORE_GET_OTHERINFO failed'));
    });
  });
}

/**
 * 获取静默安装缺省安装路径
 * @param {*} path
 */
function getQuietInstallPath(path) {
  return new Promise((resolve, reject) => {
    bridge.requestNative('APPSTORE_GET_QUIET_INSTALL_PATH', path, (success, message) => {
      if (success) {
        let ret = {};
        try {
          ret = JSON.parse(message);
        } catch (error) {
          logNative(`接口调用 APPSTORE_GET_QUIET_INSTALL_PATH JSON解析错误:${error}`, error);
        }
        return resolve(ret);
      }
      return reject(new Error('APPSTORE_GET_QUIET_INSTALL_PATH failed'));
    });
  });
}

/**
 * 设置静默安装缺省安装路径
 * @param {*} path
 */
function setQuietInstallPath(path) {
  return new Promise((resolve, reject) => {
    bridge.requestNative('APPSTORE_SET_QUIET_INSTALL_PATH', path, (success, message) => {
      if (success) {
        let ret = {};
        try {
          ret = JSON.parse(message);
          return resolve(ret);
        } catch (error) {
          logNative(`接口调用 APPSTORE_SET_QUIET_INSTALL_PATH JSON解析错误:${error}`, error);
          return reject(error);
        }
      }
      return reject(new Error('APPSTORE_SET_QUIET_INSTALL_PATH failed'));
    });
  });
}

/**
 * 设置下载文件保存路径
 * @param {*} path
 */
function setDownloadPath(path) {
  return new Promise((resolve, reject) => {
    bridge.requestNative('APPSTORE_SET_DOWNLOAD_PATH', path, (success, message) => {
      if (success) {
        let ret = {};
        try {
          ret = JSON.parse(message);
          return resolve(ret);
        } catch (error) {
          logNative(`接口调用 APPSTORE_SET_DOWNLOAD_PATH JSON解析错误:${error}`, error);
          return reject(error);
        }
      }
      return reject(new Error('APPSTORE_SET_DOWNLOAD_PATH failed'));
    });
  });
}

/**
 * 弹出选择文件夹框，如果取消，则返回传入的路径
 * @param {*} currPath
 */
function browserFolder(currPath) {
  return new Promise((resolve, reject) => {
    bridge.requestNative('APPSTORE_BROWSER_FOLDER', currPath, (success, message) => {
      if (success) {
        let ret = {};
        try {
          ret = JSON.parse(message);
        } catch (error) {
          logNative(`接口调用 APPSTORE_BROWSER_FOLDER JSON解析错误:${error}`, error);
        }
        resolve(ret);
      } else {
        reject(new Error('APPSTORE_BROWSER_FOLDER failed'));
      }
    });
  });
}

/**
 * 打开某一个路径
 * @param {*} path
 */
function openFolder(path) {
  bridge.requestNative('APPSTORE_OPEN_FOLDER', path);
}

/**
 * 壁纸
 * 请求取消下载某个图片
 */
function wpCancelDownloadImg({ id }) {
  bridge.requestNative('APPSTORE_CANCEL_DOWN_WALLPAPER', JSON.stringify({ id }));
}

/**
 * 壁纸
 * 请求放大窗口，用于预览图片
 */
function wpMaximizeStroe() {
  return new Promise((resolve, reject) => {
    bridge.requestNative('APPSTORE_REQ_PREVIEW_WALLPAPER', null, (success, message) => {
      if (success) {
        let ret = {};
        try {
          ret = JSON.parse(message);
          logNative(
            `接口调用 APPSTORE_REQ_PREVIEW_WALLPAPER 请求放大窗口，用于预览图片`,
            ret,
            true,
            true,
          );
        } catch (error) {
          logNative(`接口调用 APPSTORE_REQ_PREVIEW_WALLPAPER JSON解析错误:${error}`, error);
        }
        resolve(ret);
      } else {
        reject(new Error('APPSTORE_REQ_PREVIEW_WALLPAPER failed'));
      }
    });
  });
}

/**
 * 壁纸
 * 请求缩小窗口到正常，用于退出预览图片
 */
function wpExitMaximizeStroe() {
  return new Promise((resolve, reject) => {
    bridge.requestNative('APPSTORE_REQ_ESC_PREVIEW', null, (success, message) => {
      if (success) {
        let ret = {};
        try {
          ret = JSON.parse(message);
          logNative(
            `接口调用 APPSTORE_REQ_PREVIEW_WALLPAPER 请求缩小窗口，预览图片结束`,
            ret,
            true,
            true,
          );
        } catch (error) {
          logNative(`接口调用 APPSTORE_REQ_ESC_PREVIEW JSON解析错误:${error}`, error);
        }
        resolve(ret);
      } else {
        reject(new Error('APPSTORE_REQ_ESC_PREVIEW failed'));
      }
    });
  });
}

/**
 * H5设置自动清理状态
 */
function settingAutoClearApp({ autoclean, spanday }) {
  return new Promise((resolve, reject) => {
    bridge.requestNative(
      'APPSTORE_SET_AUTOCLEAN',
      JSON.stringify({ autoclean, spanday }),
      (success, message) => {
        if (success) {
          let ret = {};
          try {
            ret = JSON.parse(message);
            logNative(
              `接口调用 APPSTORE_SET_AUTOCLEAN 设置自动清理状态,调用结果：${JSON.stringify(
                ret,
              )} ${autoclean} ${spanday}`,
              {},
              true,
              true,
            );
          } catch (error) {
            logNative(`接口调用 APPSTORE_SET_AUTOCLEAN JSON解析错误:${error}`, error);
          }
          resolve(ret);
        } else {
          reject(new Error('APPSTORE_SET_AUTOCLEAN failed'));
        }
      },
    );
  });
}

/**
 * 获取软件卸载残留的文件和注册列表残留
 */
function getSoftwareListResidual() {
  logNative(`接口调用 APPSTORE_REQ_RESIDUAL_LIST 开始调用`, {}, true, true);
  return new Promise((resolve, reject) => {
    bridge.requestNative('APPSTORE_REQ_RESIDUAL_LIST', JSON.stringify({}), (success, message) => {
      if (success) {
        try {
          const res = JSON.parse(message);
          resolve(res);
          logNative(`接口调用 APPSTORE_REQ_RESIDUAL_LIST 结束调用`, message);
        } catch (error) {
          logNative(`接口调用 APPSTORE_REQ_RESIDUAL_LIST JSON解析错误:${error}`, error);
        }
      } else {
        reject(new Error('APPSTORE_REQ_SET_WALLPAPER failed'));
      }
    });
  });
}

function getRightMenuInfo() {
  return new Promise((resolve, reject) => {
    bridge.requestNative(
      'APPSTORE_REQ_RIGHT_MENU_STATUS',
      JSON.stringify({}),
      (success, message) => {
        if (success) {
          let ret = {};
          try {
            ret = JSON.parse(message);
            logNative(
              `接口调用 APPSTORE_REQ_RIGHT_MENU_STATUS 获取右键菜单开关 结果：${message}`,
              {},
              true,
              true,
            );
          } catch (error) {
            logNative(`接口调用 APPSTORE_REQ_RIGHT_MENU_STATUS JSON解析错误:${error}`, error);
          }
          resolve(ret);
        } else {
          reject(new Error('APPSTORE_REQ_RIGHT_MENU_STATUS failed'));
        }
      },
    );
  });
}
/**
 * H5设置右键菜单开关
 */
function settingRightMenu({ enable, source, wallpaperEnable, recommendEnable }) {
  logNative(
    `接口调用 APPSTORE_REQ_SET_RIGHT_MENU 键菜单开关参数: ${!!enable} ${source} ${!!wallpaperEnable} ${!!recommendEnable}`,
    {},
    true,
    true,
    true,
  );
  return new Promise((resolve, reject) => {
    bridge.requestNative(
      'APPSTORE_REQ_SET_RIGHT_MENU',
      JSON.stringify({
        enable: !!enable,
        source,
        wallpaperEnable: !!wallpaperEnable,
        recommendEnable: !!recommendEnable,
      }),
      (success, message) => {
        if (success) {
          let ret = {};
          try {
            ret = JSON.parse(message);
            logNative(
              `接口调用 APPSTORE_REQ_SET_RIGHT_MENU H5设置右键菜单开关enable: ${enable} ${wallpaperEnable} ${recommendEnable} 结果：${JSON.stringify(
                ret,
              )}`,
              {},
              true,
              true,
              true,
            );
          } catch (error) {
            logNative(`接口调用 APPSTORE_REQ_SET_RIGHT_MENU JSON解析错误:${error}`, error);
          }
          resolve(ret);
        } else {
          reject(new Error('APPSTORE_REQ_SET_RIGHT_MENU failed'));
        }
      },
    );
  });
}

/**
 * H5设置壁纸换一换
 */
function settingRightWallpaper({ wallpaperEnable, source }) {
  logNative(
    `接口调用 APPSTORE_REQ_SET_RIGHT_MENU 键菜单开关参数: ${!!wallpaperEnable} ${source}`,
    {},
    true,
    true,
  );
  return new Promise((resolve, reject) => {
    bridge.requestNative(
      'APPSTORE_REQ_SET_RIGHT_MENU',
      JSON.stringify({ wallpaperEnable: !!wallpaperEnable, source }),
      (success, message) => {
        if (success) {
          let ret = {};
          try {
            ret = JSON.parse(message);
            logNative(
              `接口调用 APPSTORE_REQ_SET_RIGHT_MENU H5设置右键菜单开关enable: ${wallpaperEnable} 结果：${JSON.stringify(
                ret,
              )}`,
              {},
              true,
              true,
            );
          } catch (error) {
            logNative(`接口调用 APPSTORE_REQ_SET_RIGHT_MENU JSON解析错误:${error}`, error);
          }
          resolve(ret);
        } else {
          reject(new Error('APPSTORE_REQ_SET_RIGHT_MENU failed'));
        }
      },
    );
  });
}

/**
 *
 */
function getSoftwareResidual(params) {
  logNative(`接口调用 APPSTORE_REQ_SOFTWARE_RESIDUAL 开始调用`, JSON.stringify(params), true, true);
  return new Promise((resolve, reject) => {
    bridge.requestNative(
      'APPSTORE_REQ_SOFTWARE_RESIDUAL',
      JSON.stringify(params),
      (success, message) => {
        if (!success) {
          reject(new Error(`APPSTORE_REQ_SOFTWARE_RESIDUAL ${message}`));
        }
      },
    );
  });
}

/**
 *
 */
function deleteSoftwareResidual(params) {
  logNative(`接口调用 APPSTORE_REQ_DELETE_RESIDUAL 开始调用`, JSON.stringify(params), true, true);
  return new Promise((resolve, reject) => {
    bridge.requestNative(
      'APPSTORE_REQ_DELETE_RESIDUAL',
      JSON.stringify(params),
      (success, message) => {
        if (!success) {
          reject(new Error(`APPSTORE_REQ_DELETE_RESIDUAL failed ${message}`));
        }
      },
    );
  });
}

// 停止残留扫描
function stopScanSoftwareResidual(params) {
  logNative(
    `接口调用 APPSTORE_REQ_STOP_SCAN_RESIDUAL 开始调用`,
    JSON.stringify(params),
    true,
    true,
  );
  return new Promise(() => {
    bridge.requestNative('APPSTORE_REQ_STOP_SCAN_RESIDUAL', JSON.stringify(params));
  });
}
// 移除残留软件列表中某条残留记录
function removeSoftwareResidual(params) {
  logNative(
    `接口调用 APPSTORE_REQ_DELETE_RESIDUAL_INFO 开始调用`,
    JSON.stringify(params),
    true,
    true,
  );
  return new Promise(() => {
    logNative(`APPSTORE_REQ_DELETE_RESIDUAL_INFO 移除残留记录 ${params}`);
    bridge.requestNative('APPSTORE_REQ_DELETE_RESIDUAL_INFO', JSON.stringify(params));
  });
}

/**
 * 获取是否需要更新PC商店
 */
function isNeedUpdatePCStore() {
  return new Promise((resolve, reject) => {
    logNative(`开始 接口调用 INDE_GET_LATEST_UPDATE 获取是否需要更新PCstore`, {}, true, true);
    bridge.requestNative('INDE_GET_LATEST_UPDATE', {}, (success, message) => {
      if (success) {
        let ret = {};
        try {
          ret = JSON.parse(message);
          logNative(
            `接口调用 INDE_GET_LATEST_UPDATE 获取是否需要更新PCstore,调用结果：${JSON.stringify(
              ret,
            )}`,
            {},
            true,
            true,
          );
          resolve(ret);
        } catch (error) {
          resolve(ret);
          logNative(`接口调用 INDE_GET_LATEST_UPDATE JSON解析错误:${error}`, error);
        }
      } else {
        reject(new Error('INDE_GET_LATEST_UPDATE failed'));
      }
    });
  });
}
/**
 * 开始安装更新PC商店
 */
function updatePCStore(param) {
  logNative(`开始 接口调用 INDE_UPGRADE_INSTALL  开始安装更新PC商店`, {}, true, true);
  return new Promise((resolve, reject) => {
    bridge.requestNative(
      'INDE_UPGRADE_INSTALL',
      JSON.stringify({ ...param }),
      (success, message) => {
        if (success) {
          let ret = {};
          try {
            ret = JSON.parse(message);
            logNative(
              `接口调用 INDE_UPGRADE_INSTALL 更新PCstore,调用结果：${JSON.stringify(ret)}`,
              {},
              true,
              true,
            );
          } catch (error) {
            logNative(`接口调用 INDE_UPGRADE_INSTALL JSON解析错误:${error}`, error);
          }
          resolve(ret);
        } else {
          reject(new Error('INDE_UPGRADE_INSTALL failed'));
        }
      },
    );
  });
}

/**
 * 获取用户静默自更新 自升级开关状态
 */
function getUpdatePCStoreState(param) {
  return new Promise((resolve, reject) => {
    bridge.requestNative(
      'INDE_GET_CUSTOM_QUIET_UPGRADE',
      JSON.stringify({ ...param }),
      (success, message) => {
        if (success) {
          let ret = {};
          try {
            ret = JSON.parse(message);
            logNative(
              `接口调用 INDE_GET_CUSTOM_QUIET_UPGRADE 获取用户静默自更新开关状态,调用结果：${JSON.stringify(
                ret,
              )}`,
              {},
              true,
              true,
            );
          } catch (error) {
            logNative(`接口调用 INDE_GET_CUSTOM_QUIET_UPGRADE JSON解析错误:${error}`, error);
          }
          resolve(ret);
        } else {
          reject(new Error('INDE_GET_CUSTOM_QUIET_UPGRADE failed'));
        }
      },
    );
  });
}

/**
 * 设置用户静默自更新开关状态
 */
function setUpdatePCStoreState(param) {
  const { userQuietUpgrade } = param;
  bridge.requestNative('INDE_PUT_CUSTOM_QUIET_UPGRADE', JSON.stringify({ userQuietUpgrade }));
  logNative(
    `接口调用 INDE_PUT_CUSTOM_QUIET_UPGRADE 设置自动更新开关状态: ${JSON.stringify(param)}`,
    {},
    true,
    true,
  );
}

/**
 * H5请求C++获取软件GUID和软件位数
 */
function getSoftwareAndBits(param) {
  return new Promise((resolve, reject) => {
    logNative(
      `接口开始调用 APPSTORE_REQ_SOFTWARE_GUID_AND_BITS C++获取软件GUID和软件位数,${JSON.stringify(
        param,
      )}`,
      {},
      true,
      true,
    );
    bridge.requestNative(
      'APPSTORE_REQ_SOFTWARE_GUID_AND_BITS',
      JSON.stringify(param),
      (success, message) => {
        if (success) {
          let ret = {};
          try {
            ret = JSON.parse(message);
            logNative(
              `接口调用 APPSTORE_REQ_SOFTWARE_GUID_AND_BITS C++获取软件GUID和软件位数结果：${message}`,
              {},
              true,
              true,
            );
          } catch (error) {
            logNative(`接口 APPSTORE_REQ_SOFTWARE_GUID_AND_BITS JSON解析错误:${error}`, error);
          }
          resolve(ret);
        } else {
          reject(new Error('APPSTORE_REQ_SOFTWARE_GUID_AND_BITS failed'));
        }
      },
    );
  });
}

/**
 * H5设置商店磁铁
 * "source": int /* 1：设置中心勾选框创建；2：关闭商店时创建；3：创建商店时创建
 * @param {*} param0
 */
function settingPCStoreTile({ enable, source }) {
  logNative(
    `接口调用 APPSTORE_REQ_SET_UNINSTALL_TILE_NO_RETURN 商店磁铁参数: ${!!enable} ${source}`,
    {},
    true,
    true,
  );
  return new Promise((resolve, reject) => {
    bridge.requestNative(
      'APPSTORE_REQ_SET_UNINSTALL_TILE_NO_RETURN',
      JSON.stringify({ enable: !!enable, source }),
      (success, message) => {
        logNative(
          `接口调用 APPSTORE_REQ_SET_UNINSTALL_TILE_NO_RETURN 商店磁铁: ${!!enable} ${source}  结果：${message}`,
          {},
          true,
          true,
        );
        if (success) {
          let ret = {};
          try {
            ret = JSON.parse(message);
          } catch (error) {
            logNative(
              `接口调用 APPSTORE_REQ_SET_UNINSTALL_TILE_NO_RETURN JSON解析错误:${error}`,
              error,
            );
          }
          resolve(ret);
        } else {
          reject(new Error('APPSTORE_REQ_SET_UNINSTALL_TILE_NO_RETURN failed'));
        }
      },
    );
  });
}

/**
 * 获取磁铁状态
 */
function getPCStoreTileStatus() {
  return new Promise((resolve, reject) => {
    bridge.requestNative(
      'APPSTORE_REQ_GET_UNINSTALL_TILE_STATUS',
      JSON.stringify({}),
      (success, message) => {
        if (success) {
          let ret = {};
          try {
            ret = JSON.parse(message);
            logNative(
              `接口调用 APPSTORE_REQ_GET_UNINSTALL_TILE_STATUS 商店磁铁 结果：${message}`,
              {},
              true,
              true,
            );
          } catch (error) {
            logNative(
              `接口调用 APPSTORE_REQ_GET_UNINSTALL_TILE_STATUS JSON解析错误:${error}`,
              error,
            );
          }
          resolve(ret);
        } else {
          reject(new Error('APPSTORE_REQ_GET_UNINSTALL_TILE_STATUS failed'));
        }
      },
    );
  });
}

/**
 * 打开选择指定文件类型弹窗
 */
function openSpecialFolder(params) {
  return new Promise((resolve, reject) => {
    bridge.requestNative(
      'APPSTORE_REQ_OPEN_FOLDER_AND_SELECT_PIC',
      JSON.stringify({ params }),
      (success, message) => {
        if (success) {
          let ret = {};
          try {
            ret = JSON.parse(message);
            logNative(
              `接口调用 APPSTORE_REQ_OPEN_FOLDER_AND_SELECT_PIC 打开文件选择对话框 结果：${message}`,
              {},
              true,
              true,
            );
          } catch (error) {
            logNative(
              `接口调用 APPSTORE_REQ_OPEN_FOLDER_AND_SELECT_PIC JSON解析错误:${error}`,
              error,
            );
          }
          resolve(ret);
        } else {
          reject(new Error('APPSTORE_REQ_OPEN_FOLDER_AND_SELECT_PIC failed'));
        }
      },
    );
  });
}

/**
 * 提交用户反馈消息
 */
function submitFeedbackInfo(params) {
  return new Promise((resolve, reject) => {
    bridge.requestNative(
      'APPSTORE_REQ_SUBMIT_FEEDBACK',
      JSON.stringify({ ...params }),
      (success, message) => {
        if (success) {
          let ret = {};
          try {
            ret = JSON.parse(message);
            logNative(
              `接口调用 APPSTORE_REQ_SUBMIT_FEEDBACK 提交用户反馈信息 结果：${message}`,
              {},
              true,
              true,
            );
          } catch (error) {
            logNative(`接口调用 APPSTORE_REQ_SUBMIT_FEEDBACK JSON解析错误:${error}`, error);
          }
          resolve(ret);
        } else {
          reject(new Error('APPSTORE_REQ_SUBMIT_FEEDBACK failed'));
        }
      },
    );
  });
}

/**
 * 调起另一个商店，并且打开某一个页面
 */
function openOtherStore(params) {
  return new Promise((resolve, reject) => {
    const param = {};
    if (params.x) param.x = params.x;
    if (params.y) param.y = params.y;
    if (params.width) param.width = params.width;
    if (params.height) param.height = params.height;
    if (params.topmost) param.topmost = params.topmost;
    if (params.dbgUrlBar) {
      param.dbgUrlBar = params.dbgUrlBar;
      param.url =
        params.url || `https://pc.lenovomm.cn/embedded_v7_0/speciallist?pageType=detail&ztType=all`;
    }
    if (params.url) param.url = params.url;

    bridge.requestNative(
      'APPSTORE_REQ_POPUP_WINDOW',
      JSON.stringify({ ...param }),
      (success, message) => {
        if (success) {
          let ret = {};
          try {
            ret = JSON.parse(message);
            logNative(
              `接口调用 APPSTORE_REQ_POPUP_WINDOW 调起另一个商店，并且打开某一个页面 结果：${message}`,
              {},
              true,
              true,
            );
          } catch (error) {
            logNative(
              `接口调用 APPSTORE_REQ_POPUP_WINDOW 调起另一个商店，并且打开某一个页面 JSON解析错误:${error}`,
              error,
            );
          }
          resolve(ret);
        } else {
          reject(new Error('APPSTORE_REQ_POPUP_WINDOW failed'));
        }
      },
    );
  });
}

/**
 *
 * @param {通用协议开关} params
 * @returns
 */

function setAppStoreSwitch(params) {
  return new Promise((resolve, reject) => {
    bridge.requestNative(
      'APPSTORE_REQ_SET_SWITCH',
      JSON.stringify({ ...params }),
      (success, message) => {
        if (success) {
          let ret = {};
          try {
            ret = JSON.parse(message);
            logNative(
              `接口调用 APPSTORE_REQ_SET_SWITCH 通用开关协议 结果：${message}`,
              params,
              true,
              true,
            );
            resolve(ret);
          } catch (error) {
            logNative(
              `接口调用  APPSTORE_REQ_SET_SWITCH 通用开关协议 JSON解析错误:${error}`,
              params,
            );
            reject(ret);
          }
        } else {
          reject(new Error('APPSTORE_REQ_SET_SWITCH failed'));
        }
      },
    );
  });
}

/**
 * 通用协议开关获取
 */
function getAppStoreSwitch(params) {
  return new Promise((resolve, reject) => {
    bridge.requestNative(
      'APPSTORE_REQ_SWITCH_STATUS',
      JSON.stringify({ ...params }),
      (success, message) => {
        if (success) {
          let ret = {};
          try {
            ret = JSON.parse(message);
            logNative(
              `接口调用 APPSTORE_REQ_SWITCH_STATUS 获取通用开关${params}状态 结果：${message}`,
              params,
              true,
              true,
            );
            resolve(ret);
          } catch (error) {
            logNative(
              `接口调用  APPSTORE_REQ_SWITCH_STATUS 获取通用开关${params}状态 JSON解析错误:${error}`,
              params,
            );
            reject(ret);
          }
        } else {
          reject(new Error('APPSTORE_REQ_SWITCH_STATUS failed'));
        }
      },
    );
  });
}
/**
 * 获取不常用软件
 */
function getNotOftenUsedSofts() {
  return new Promise((resolve, reject) => {
    bridge.requestNative(
      'APPSTORE_REQ_REARELY_SOFTINFO',
      JSON.stringify({ type: '3' }),
      (success, message) => {
        if (success) {
          let ret = {};
          try {
            ret = JSON.parse(message);
            resolve((ret && ret.data && ret.data.data) || []);
            logNative(
              `接口调用 APPSTORE_REQ_REARELY_SOFTINFO 获取不常用软件 结果：${message}`,
              ret.data.data,
              true,
              true,
            );
          } catch (error) {
            logNative(
              `接口调用  APPSTORE_REQ_REARELY_SOFTINFO 获取不常用软件 JSON解析错误:${error}`,
            );
            reject(ret);
          }
        } else {
          reject(new Error('APPSTORE_REQ_REARELY_SOFTINFO failed'));
        }
      },
    );
  });
}

// FC_DL_LIST 获取下载任务列表
function downloadList(param = {}) {
  return new Promise((resolve, reject) => {
    bridge.requestNative('FC_DL_LIST', JSON.stringify({ ...param }), (success, message) => {
      if (success) {
        let ret = {};
        try {
          ret = JSON.parse(message);

          if (ret && ret.code === 0 && ret.data) {
            resolve(ret.data || {});
          } else {
            reject(ret);
          }
          logNative(`接口调用 FC_DL_LIST  结果：${message}`, ret);
        } catch (error) {
          logNative(`接口调用  FC_DL_LIST  JSON解析错误:${error}`);
          reject(ret);
        }
      } else {
        reject(new Error('FC_DL_LIST failed'));
      }
    });
  });
}
// FC_DL_ADD 下载，添加下载任务
function downloadAdd(param) {
  let soft = {};
  if (param.androidType === '1') {
    soft.type = 'apk';
    soft.apk = {
      pkg: param.packageName,
      vc: param.versionCode,
      vn: param.version,
      BizInfo: typeof param.bizInfo === 'object' ? JSON.stringify(param.bizInfo) : param.bizInfo,
      LogoFile: param.logoFile,
      SoftName: param.softName,
    };
    if (param.logInfo) {
      soft.apk.LogInfo = JSON.stringify({
        source: param.logInfo.source,
        source_p: param.logInfo.source_p,
        source_pp: param.logInfo.source_pp,
        search_type: param.logInfo.search_type || undefined,
        search_word: param.logInfo.search_word || undefined,
        type: param.logInfo.type || 'd',
      });
    }
  } else {
    soft = {
      type: 'pc',
      pc: capitalizeObj({
        ...param,
        bizInfo: typeof param.bizInfo === 'object' ? JSON.stringify(param.bizInfo) : param.bizInfo,
        softID: param.SoftID || param.softID || param.SoftId || param.softId,
        version: param.version,
        installparams: param.installparams || {},
      }),
    };

    if (param.logInfo) {
      soft.pc.LogInfo = JSON.stringify({
        source: param.logInfo.source,
        source_p: param.logInfo.source_p,
        source_pp: param.logInfo.source_pp,
        search_type: param.logInfo.search_type || undefined,
        search_word: param.logInfo.search_word || undefined,
        type: param.logInfo.type || 'd',
      });
    }
  }

  logNative(`接口调用 FC_DL_ADD 添加下载任务 参数：${JSON.stringify({ ...soft })}`);
  return new Promise((resolve, reject) => {
    bridge.requestNative('FC_DL_ADD', JSON.stringify({ ...soft }), (success, message) => {
      if (success) {
        let ret = {};
        try {
          ret = JSON.parse(message);
          resolve(ret);
          logNative(
            `接口调用 FC_DL_ADD 参数：${JSON.stringify({ ...soft })}  结果：${message}`,
            ret,
          );
        } catch (error) {
          logNative(
            `接口调用  FC_DL_ADD 参数：${JSON.stringify({ ...soft })}  JSON解析错误:${error}`,
          );
          reject(ret);
        }
      } else {
        reject(new Error('FC_DL_ADD failed'));
      }
    });
  });
}
// FC_DL_CANCEL 取消下载安装任务
function downloadCancel(param) {
  return new Promise((resolve, reject) => {
    bridge.requestNative('FC_DL_CANCEL', JSON.stringify({ ...param }), (success, message) => {
      if (success) {
        let ret = {};
        try {
          ret = JSON.parse(message);
          resolve(ret);
          logNative(
            `接口调用 FC_DL_CANCEL 参数：${JSON.stringify({ ...param })}  结果：${message}`,
            ret,
          );
        } catch (error) {
          logNative(
            `接口调用  FC_DL_CANCEL 参数：${JSON.stringify({ ...param })}  JSON解析错误:${error}`,
          );
          reject(ret);
        }
      } else {
        reject(new Error('FC_DL_CANCEL failed'));
      }
    });
  });
}
// FC_DL_RETRY 重试任务
function downloadRetry(param) {
  return new Promise((resolve, reject) => {
    bridge.requestNative('FC_DL_RETRY', JSON.stringify({ ...param }), (success, message) => {
      if (success) {
        let ret = {};
        try {
          ret = JSON.parse(message);
          resolve(ret);
          logNative(
            `接口调用 FC_DL_RETRY 参数：${JSON.stringify({ ...param })}  结果：${message}`,
            ret,
          );
        } catch (error) {
          logNative(
            `接口调用  FC_DL_RETRY 参数：${JSON.stringify({ ...param })}  JSON解析错误:${error}`,
          );
          reject(ret);
        }
      } else {
        reject(new Error('FC_DL_RETRY failed'));
      }
    });
  });
}
// FC_DL_PAUSE 暂停下载任务
function downloadPause(param) {
  return new Promise((resolve, reject) => {
    bridge.requestNative('FC_DL_PAUSE', JSON.stringify({ ...param }), (success, message) => {
      if (success) {
        let ret = {};
        try {
          ret = JSON.parse(message);
          resolve(ret);
          logNative(
            `接口调用 FC_DL_PAUSE 参数：${JSON.stringify({ ...param })}  结果：${message}`,
            ret,
          );
        } catch (error) {
          logNative(
            `接口调用  FC_DL_PAUSE 参数：${JSON.stringify({ ...param })}  JSON解析错误:${error}`,
          );
          reject(ret);
        }
      } else {
        reject(new Error('FC_DL_PAUSE failed'));
      }
    });
  });
}
// FC_DL_RESUME 继续下载任务
function downloadResume(param) {
  return new Promise((resolve, reject) => {
    bridge.requestNative('FC_DL_RESUME', JSON.stringify({ ...param }), (success, message) => {
      if (success) {
        let ret = {};
        try {
          ret = JSON.parse(message);
          resolve(ret);
          logNative(
            `接口调用 FC_DL_RESUME 参数：${JSON.stringify({ ...param })}  结果：${message}`,
            ret,
          );
        } catch (error) {
          logNative(
            `接口调用  FC_DL_RESUME 参数：${JSON.stringify({ ...param })}  JSON解析错误:${error}`,
          );
          reject(ret);
        }
      } else {
        reject(new Error('FC_DL_RESUME failed'));
      }
    });
  });
}
// FC_DL_STATE 获取指定应用下载任务状态
function downloadSoftState(param) {
  return new Promise((resolve, reject) => {
    bridge.requestNative('FC_DL_STATE', JSON.stringify({ ...param }), (success, message) => {
      if (success) {
        let ret = {};
        try {
          ret = JSON.parse(message);
          resolve(ret);
          logNative(`接口调用 FC_DL_STATE  结果：${message}`, ret);
        } catch (error) {
          logNative(`接口调用  FC_DL_STATE  JSON解析错误:${error}`);
          reject(ret);
        }
      } else {
        reject(new Error('FC_DL_STATE failed'));
      }
    });
  });
}

// 获取壁纸下载地址
function setWpDownloadPath(path) {
  return new Promise((resolve, reject) => {
    bridge.requestNative('AS_WP_SET_PATH', `${path}`, (success, message) => {
      if (success) {
        let ret = {};
        try {
          ret = JSON.parse(message);
          resolve(ret);
          logNative(`接口调用 AS_WP_SET_PATH  结果：${message}`, ret);
        } catch (error) {
          logNative(`接口调用  AS_WP_SET_PATH  JSON解析错误:${error}`);
          reject(ret);
        }
      } else {
        reject(new Error('AS_WP_SET_PATH failed'));
      }
    });
  });
}

// 获取壁纸下载路径
function getWallpaperDPath(param) {
  return new Promise((resolve, reject) => {
    bridge.requestNative('AS_WP_GET_PATH', JSON.stringify({ ...param }), (success, message) => {
      if (success) {
        let ret = {};
        try {
          ret = JSON.parse(message);
          resolve(ret);
          logNative(`接口调用 AS_WP_GET_PATH  结果：${message}`, ret);
        } catch (error) {
          logNative(`接口调用  AS_WP_GET_PATH  JSON解析错误:${error}`);
          reject(ret);
        }
      } else {
        reject(new Error('AS_WP_GET_PATH failed'));
      }
    });
  });
}

/**
 * 8.0 壁纸设置下载路径
 * @param {*} path
 */
function setWallpaperDPath(path) {
  return new Promise((resolve, reject) => {
    bridge.requestNative('AS_WP_SET_PATH', path, (success, message) => {
      if (success) {
        let ret = {};
        try {
          ret = JSON.parse(message);
          logNative(`接口调用 AS_WP_SET_PATH  结果：${message}`, ret);
          return resolve(ret);
        } catch (error) {
          logNative(`接口调用 AS_WP_SET_PATH JSON解析错误:${error}`, error);
          return reject(error);
        }
      }
      return reject(new Error('AS_WP_SET_PATH failed'));
    });
  });
}

// 8.5壁纸轮播开启设置
function switchWpOpenTurn(param) {
  return new Promise((resolve, reject) => {
    bridge.requestNative(
      'APPSTORE_REQ_CARSOUSEL_WALLPAPER',
      JSON.stringify(param),
      (success, message) => {
        if (success) {
          try {
            resolve(JSON.parse(message));
            logNative(
              `设置壁纸轮播 APPSTORE_REQ_CARSOUSEL_WALLPAPER, params: ${JSON.stringify(
                param,
              )}; 相应${success}, message${message}`,
            );
          } catch (error) {
            logNative(`接口调用  APPSTORE_REQ_CARSOUSEL_WALLPAPER  JSON解析错误:${error}`);
            reject(JSON.parse(message));
          }
        } else {
          reject(new Error('APPSTORE_REQ_CARSOUSEL_WALLPAPER failed'));
        }
      },
    );
  });
}

/**
 * 8.0下载壁纸新接口（加密下载）（8.5修改）
 * param = { id, url, type, code, bizinfo };
 * id	壁纸id	string	"id":"u-u-i-d"	yes
 * url	壁纸下载地址	string	"id":"http://..."	no
 * type	下载来源	string	透传给H5的	yes
 * code	下载来源	string	透传给H5的	yes
 * bizinfo	事件来源	object	{"biz":...}	yes
 */
function wpDownloadImg({ id, url, type, code = '', bizinfo = '{}' }) {
  return new Promise((resolve, reject) => {
    bridge.requestNative(
      'APPSTORE_DOWN_WALLPAPER',
      JSON.stringify({ id, url, type, code, bizinfo }),
      (success, message) => {
        if (success) {
          let ret = {};
          try {
            ret = JSON.parse(message);
            logNative(
              `接口调用 APPSTORE_DOWN_WALLPAPER 请求下载某个图片${JSON.stringify(ret)}`,
              {},
            );
          } catch (error) {
            logNative(`接口调用 APPSTORE_DOWN_WALLPAPER JSON解析错误:${error}`, error);
          }
          resolve(ret);
        } else {
          reject(new Error('APPSTORE_DOWN_WALLPAPER failed'));
        }
      },
    );
  });
}

/**
 * 8.0 壁纸下载购买的壁纸（非加密下载）（8.5修改）
 * param:
 * id	壁纸id	string	"id":"97012"	yes
 * url	壁纸下载地址	string	"id":"http://..."	no
 * type	下载来源	string	透传给H5的	yes
 * code	下载来源	string	透传给H5的	yes
 * bizinfo	事件来源	object	{"biz":...}	yes
 * @returns
 */
function requestWpBuyDownload({ id, url, type, code = '', bizinfo = '{}' }) {
  return new Promise((resolve, reject) => {
    let param = { id, url, type, code, bizinfo };
    bridge.requestNative('AS_WP_BUY_DOWNLOAD', JSON.stringify(param), (success, message) => {
      logNative(`下载壁纸请求，params：${JSON.stringify(param)};响应${success},message${message}`);
      if (success) {
        let ret = {};
        try {
          ret = JSON.parse(message);
          resolve(ret);
          logNative(`接口调用 AS_WP_BUY_DOWNLOAD  结果：${message}`, ret);
        } catch (error) {
          logNative(`接口调用  AS_WP_BUY_DOWNLOAD  JSON解析错误:${error}`);
          reject(ret);
        }
      } else {
        reject(new Error('AS_WP_BUY_DOWNLOAD failed'));
      }
    });
  });
}

/**
 * 壁纸
 * 查询壁纸是否已经下载存在于目录中
 * id	  壁纸id	string	yes
 * url	壁纸下载地址	string	yes
 */
function wpIsDownloadedImg({ url, id, name = '' }) {
  return new Promise((resolve, reject) => {
    bridge.requestNative(
      'APPSTORE_REQ_WALLPAPER_EXIST',
      JSON.stringify({ id, url }),
      (success, message) => {
        if (success) {
          let ret = {};
          try {
            ret = JSON.parse(message);
            logNative(
              `接口调用 APPSTORE_REQ_WALLPAPER_EXIST 查询壁纸是否已经下载存在于目录中${JSON.stringify(
                ret,
              )}, ${id}, ${url}`,
              {},
            );
          } catch (error) {
            logNative(
              `接口调用 APPSTORE_REQ_WALLPAPER_EXIST JSON解析错误:${error}, ${id}, ${url}`,
              error,
            );
          }
          resolve(ret);
        } else {
          reject(new Error('APPSTORE_REQ_WALLPAPER_EXIST failed'));
        }
      },
    );
  });
}

/**
 * 壁纸请求 设为壁纸
 * id	壁纸id	string	yes	用于报桩
 * url	壁纸下载地址	string	yes
 */
function wpSetWallpaper({ url, id, name = '' }) {
  logNative(`接口调用 APPSTORE_REQ_SET_WALLPAPER 开始调用 ${url} ${id}`, {}, true, true);
  return new Promise((resolve, reject) => {
    bridge.requestNative(
      'APPSTORE_REQ_SET_WALLPAPER',
      JSON.stringify({ id, url }),
      (success, message) => {
        if (success) {
          let ret = {};
          try {
            ret = JSON.parse(message);
            logNative(
              `接口调用 APPSTORE_REQ_SET_WALLPAPER 设置为壁纸${JSON.stringify(ret)} ${url} ${id}`,
              {},
            );
          } catch (error) {
            logNative(`接口调用 APPSTORE_REQ_SET_WALLPAPER JSON解析错误:${error}`, error);
          }
          resolve(ret);
        } else {
          reject(new Error('APPSTORE_REQ_SET_WALLPAPER failed'));
        }
      },
    );
  });
}

// 获取订单设备ID, 用于未登录的订单列表
function getDeviceId(param) {
  return new Promise((resolve, reject) => {
    bridge.requestNative(
      'APPSTORE_GET_DEVICEUNIQUEIDENTIFICATION',
      JSON.stringify({ ...param }),
      (success, message) => {
        if (success) {
          let ret = {};
          try {
            ret = JSON.parse(message);
            resolve(ret);
            logNative(`接口调用 APPSTORE_GET_DEVICEUNIQUEIDENTIFICATION  结果：${message}`, ret);
          } catch (error) {
            logNative(`接口调用  APPSTORE_GET_DEVICEUNIQUEIDENTIFICATION  JSON解析错误:${error}`);
            reject(ret);
          }
        } else {
          reject(new Error('APPSTORE_GET_DEVICEUNIQUEIDENTIFICATION failed'));
        }
      },
    );
  });
}

/**
 * 卸载页面打开软件
 * @param {*} mainExePath
 */
function openSoftDetermine(softInfo) {
  // bridge.requestNative('APPSTORE_DETERMINEIFAPPLICATIONEXISTS', mainExePath);
  return new Promise((resolve, reject) => {
    bridge.requestNative(
      'APPSTORE_DETERMINEIFAPPLICATIONEXISTS',
      JSON.stringify({
        SoftID: softInfo.SoftID,
        softGUID: softInfo.softGUID,
        displayName: softInfo.displayName,
        MainExePath: softInfo.MainExePath,
      }),
      (success, message) => {
        // 发起下载请求成功
        if (success) {
          try {
            const msgObj = JSON.parse(message);
            return resolve(msgObj);
          } catch (error) {
            logNative(
              `接口调用 APPSTORE_DETERMINEIFAPPLICATIONEXISTS JSON解析错误:${error}`,
              error,
            );
            return resolve(false);
          }
        }
        return reject(new Error('APPSTORE_DETERMINEIFAPPLICATIONEXISTS failed'));
      },
    );
  });
}

/**
 * 调用接口，通知客户端，可以预下载模拟器 2023-7-3 09:52:43
 */
function notifyPreDownloadSIM() {
  logNative(`接口调用 APPSTORE_REQ_PREDOWNLOAD_SIMULATOR 开始调用`, {}, true, true);
  return new Promise((resolve, reject) => {
    bridge.requestNative(
      'APPSTORE_REQ_PREDOWNLOAD_SIMULATOR',
      JSON.stringify({}),
      (success, message) => {
        if (success) {
          let ret = {};
          try {
            ret = JSON.parse(message);
            logNative(
              `接口调用 APPSTORE_REQ_PREDOWNLOAD_SIMULATOR 预下载模拟器${JSON.stringify(ret)}`,
              {},
            );
          } catch (error) {
            logNative(`接口调用 APPSTORE_REQ_PREDOWNLOAD_SIMULATOR JSON解析错误:${error}`, error);
          }
          resolve(ret);
        } else {
          reject(new Error('APPSTORE_REQ_PREDOWNLOAD_SIMULATOR failed'));
        }
      },
    );
  });
}

/**
 * 调用接口，判断商店托盘是否已经创建
 */
function storeTrayGetIsCreate() {
  logNative(`接口调用 APPSTORE_REQ_TRAY_EXIST 开始调用`, {}, true, true);
  return new Promise((resolve, reject) => {
    bridge.requestNative('APPSTORE_REQ_TRAY_EXIST', JSON.stringify({}), (success, message) => {
      if (success) {
        let ret = {};
        try {
          ret = JSON.parse(message);
          logNative(
            `接口调用 APPSTORE_REQ_TRAY_EXIST 判断商店托盘是否已经创建${JSON.stringify(ret)}`,
            {},
          );
        } catch (error) {
          logNative(`接口调用 APPSTORE_REQ_TRAY_EXIST JSON解析错误:${error}`, error);
        }
        resolve(ret);
      } else {
        reject(new Error('APPSTORE_REQ_TRAY_EXIST failed'));
      }
    });
  });
}

/**
 * 调用接口，创建托盘, 卸载托盘
 * type: 0 关闭，type: 1 关闭
 */
function storeTrayCreate(param = {}) {
  logNative(`接口调用 APPSTORE_REQ_CREATE_TRAY 开始调用`, {}, true, true);
  return new Promise((resolve, reject) => {
    bridge.requestNative(
      'APPSTORE_REQ_CREATE_TRAY',
      JSON.stringify({ type: 0, ...param }),
      (success, message) => {
        if (success) {
          let ret = {};
          try {
            ret = JSON.parse(message);
            logNative(
              `接口调用 APPSTORE_REQ_CREATE_TRAY 创建托盘 param:${JSON.stringify(
                param,
              )} ret:${JSON.stringify(ret)}`,
              {},
            );
          } catch (error) {
            logNative(`接口调用 APPSTORE_REQ_CREATE_TRAY JSON解析错误:${error}`, error);
          }
          resolve(ret);
        } else {
          reject(new Error('APPSTORE_REQ_CREATE_TRAY failed'));
        }
      },
    );
  });
}

/**
 * 调用接口，通知同步小红点
 */
function storeTrayRedPointChange(state) {
  logNative(`接口调用 APPSTORE_SET_TRAY_REDPOINT_STATUS 开始调用`, state, true, true);
  return new Promise((resolve, reject) => {
    bridge.requestNative(
      'APPSTORE_SET_TRAY_REDPOINT_STATUS',
      JSON.stringify({ state: state }),
      (success, message) => {
        if (success) {
          let ret = {};
          try {
            ret = JSON.parse(message);
            logNative(
              `接口调用 APPSTORE_SET_TRAY_REDPOINT_STATUS 通知同步小红点${JSON.stringify(
                ret,
              )}  state:${state}`,
              {},
            );
          } catch (error) {
            logNative(
              `接口调用 APPSTORE_SET_TRAY_REDPOINT_STATUS JSON解析错误:${error}`,
              error,
              state,
            );
          }
          resolve(ret);
        } else {
          reject(new Error('APPSTORE_SET_TRAY_REDPOINT_STATUS failed'));
        }
      },
    );
  });
}
export const locals = {
  downloadAdd,
  downloadCancel,
  downloadRetry,
  downloadPause,
  downloadResume,
  downloadList,
  downloadSoftState,

  judgeUninstallSoft,
  constraintUninstall,
  installAndroidSoft,
  uninstallSoft,
  startMoveWindow,
  touchStartWindow,
  touchMoveWindow,
  touchEndWindow,
  minimizeWindow,
  maximizeWindow,
  middleWindow,
  closeWindow,
  getLocalMachineInfo,
  getLocalInstalledSoft,
  cancelDownload,
  openFolder,
  getOtherInfo,
  setDownloadPath,
  checkPINExits,
  checkWALLPAPERxits,
  pinDesktopIcon,
  wallpaperDesktop,
  browserFolder,
  openSoft,
  getUpdateSoft,
  getLocalInstalledSoftNoXml,
  uninstallAndroidSoft,
  openAndroidSoft,
  cancelAndroidDownload,
  getLocalInstalledAndroidSoft,
  getAndroidPCUpdateSoft,
  getIsVTEabled,
  getIsSIMRunning,
  getIsSIMInstalled,

  getUserTokenInfo,
  getQuietInstallPath,
  setQuietInstallPath,
  getStartInfo,
  getDesktopIcon,
  createDesktopIcon,
  ignoreSoftUpdate,

  settingAutoClearApp,
  settingRightMenu,
  settingRightWallpaper,
  getRightMenuInfo,
  getSoftwareListResidual,
  getSoftwareResidual,
  deleteSoftwareResidual,
  stopScanSoftwareResidual,
  removeSoftwareResidual,

  isNeedUpdatePCStore,
  updatePCStore,
  getUpdatePCStoreState,
  setUpdatePCStoreState,
  getSoftwareAndBits,
  settingPCStoreTile,
  getPCStoreTileStatus,

  openSpecialFolder,
  submitFeedbackInfo,

  openOtherStore,
  setAppStoreSwitch,
  getAppStoreSwitch,
  getNotOftenUsedSofts,

  wpIsDownloadedImg,
  wpCancelDownloadImg,
  wpMaximizeStroe,
  wpExitMaximizeStroe,
  wpSetWallpaper,

  wpDownloadImg, // 单张壁纸下载用于预览壁纸，加密下载
  requestWpBuyDownload, // 已经购买的壁纸 下载（下载到指定目录） 非加密下载
  getWallpaperDPath,
  setWallpaperDPath,

  switchWpOpenTurn,
  getDeviceId,
  openSoftDetermine,

  notifyPreDownloadSIM,

  storeTrayGetIsCreate,
  storeTrayCreate,
  storeTrayRedPointChange,
};
